const HOTEL_CATEGORY = 'hotel';
const REGION_CATEGORY = 'region';
const LOCATION_CATEGORY = 'location';

module.exports = {
    HOTEL_CATEGORY,
    REGION_CATEGORY,
    LOCATION_CATEGORY
};